
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuCafeCoolHarajukuCafeCoolImage } from "@src/constants/images";
import { meta as uzunaomomPageMeta } from "./uzunaomom.mdx";
export const meta = {
  path: "/media/harajuku/cafe_cool",
  title: "【名店揃い】原宿でおしゃれなカフェの名店５選",
  description: "原宿エリアである領域に特化したカフェ、老舗の喫茶店、流行りの洋風なカフェなど、多彩なジャンルに分けておしゃれな名店をご紹介しています。お店ごとの行列情報、人気のメニューや、おしゃれな空間を写真付きで紹介しているので、気になるお店を是非チェックしてみてください！",
  topImg: harajukuCafeCoolHarajukuCafeCoolImage,
  author: murakamiMasanori,
  tags: ["カフェ", "老舗", "行列店", "人気店", "おしゃれな内装", "まとめ記事", "原宿", "落ち着いた雰囲気", "スイーツ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ある領域に特化したソムリエのいるカフェ、現在の多数の喫茶店の参考になった老舗の喫茶店、世界一の朝食と名高い洋風カフェ、マンションの一室にある隠れ家的名店など、多彩なジャンルに分けておしゃれな名店をご紹介しています。`}</p>
    <p>{`お店ごとの行列情報、人気のメニューや、おしゃれな空間まで写真付きで紹介しています。`}</p>
    <h2>{`カフェ香咲`}</h2>
    <InstaImage postId="CBmj3qzj9wE" mdxType="InstaImage" />
    <p>{`1984 年創業のカフェ(喫茶店)で、深煎り焙煎のネルドリップコーヒーと、全部自家製の焼きたてのホットケーキ、タルト、スコーンが楽しめるお店です。
なぜか引き込まれる、そんな雰囲気を原宿で一際放っているお店だと思います。
食べログの評価は 3.6 を超えるほどの実力派のおしゃれな人気店。`}</p>
    <h3>{`レトロな雰囲気`}</h3>
    <InstaImage postId="CBfxGJTpB7K" mdxType="InstaImage" />
    <p>{`たくさんのプランターとバスケットでお花がいっぱいな外観は古民家のような雰囲気ですが、店内は薄暗くシックなムード。
原宿とは思えない落ち着いたゆっくりとした時間を過ごしたい方には、抜群の雰囲気のカフェになっています。`}</p>
    <h3>{`豊富な料理`}</h3>
    <p>{`純粋な珈琲店(カフェ)としてスタートしたカフェ香咲ですが、「コーヒーだけだとなんだか口寂しい」と思ったところから、ホットーケーキなどをカフェとして出すようになったそう。`}</p>
    <InstaImage postId="B801phkDrRI" mdxType="InstaImage" />
    <InstaImage postId="B3bKILTgiYl" mdxType="InstaImage" />
    <p>{`厚みのある名物ホットケーキだけでなく、チーズキーマカレーやスパイシーカレーなども豊富に取り揃えており、その日の気分に合わせてメニューを楽しめるのが特徴となっています。`}</p>
    <InstaImage postId="B9JkzcZjtxQ" mdxType="InstaImage" />
    <h3>{`行列情報`}</h3>
    <p>{`原宿の中では穴場のお店なので、行列はできていないことがほとんど。落ち着いたカフェタイムを過ごしたい方には、おすすめのお店です。`}</p>
    <ShopInfoBox shopId="brmkjni23akg009e18qg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`アンセーニュダングル 原宿店`}</h2>
    <InstaImage postId="B5zpFZbgFE6" mdxType="InstaImage" />
    <p>{`カフェ香咲よりも約 10 年早い 1975 年に創業したカフェ(喫茶店)の名店。`}</p>
    <p>{`フランス語で「角の看板」を意味する店名の通り、アンセーニュ・ダングルは、原宿駅から歩いて 5 分の距離にあるにもかかわらず、静まりかえった場所に位置している原宿の中でも指折りの大人な人たちが集うおしゃれなカフェ。`}</p>
    <p>{`アンセーニュ・ダングルは、その後に回転した多くのカフェ(喫茶店)のお手本的な存在になるほどの名店。`}</p>
    <h3>{`こだわり抜いたおしゃれな空間`}</h3>
    <InstaImage postId="B9ecqmSAyJl" mdxType="InstaImage" />
    <p>{`フランスの片田舎の一軒家をイメージした空間は、全体的に重厚な雰囲気がある。アンセーニュ・ダングルのユニークな点は、テーブルに 14 本の大輪の薔薇を毎日欠かさずおいていること。空間の中での一工夫がおしゃれなカフェを作り出しているような印象を受けます。`}</p>
    <h3>{`いろんな場面に使える店内`}</h3>
    <p>{`地階への階段を降りていくとシックで薄暗い空間がに、長く艶やかな木のカウンター、奥まった半個室のようなベンチシートが出迎えてくれます。ひとりで読書、ふたりで静かなおしゃべり、数人で仕事の打ち合わせなど、原宿でのどんな状況でも居心地よく過ごすことができるおしゃれな空間。`}</p>
    <h3>{`コーヒーとスイーツ`}</h3>
    <InstaImage postId="CAfUPnuBK3Z" mdxType="InstaImage" />
    <p>{`原宿だとは思えないくらいおしゃれな空間にマッチするのが、深煎りのコーヒーと自家製のスイーツ。
ゆったりとした空間で楽しむメニューは普段とは違った体験を提供してくれること間違いなし。`}</p>
    <h3>{`行列情報`}</h3>
    <p>{`原宿の中では穴場のお店なので、行列はできていないことがほとんど。落ち着いたカフェタイムを過ごしたい方には、おすすめのお店です。`}</p>
    <ShopInfoBox shopId="brmkjni23akg009e18qg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`茶々の間`}</h2>
    <InstaImage postId="B6y7AFjgzuM" mdxType="InstaImage" />
    <p>{`日本茶を専門的に扱うお店で、日本茶ソムリエがお茶を入れてくれたり、有名な茶葉で作るおしゃれなスイーツが原宿・表参道エリアでは人気で、たくさんの行列を作ることもあります。`}</p>
    <p>{`玄米を使ったヘルシーなランチメニューまで完備しているので、カフェランチにまで対応しているお店です。`}</p>
    <h3>{`茶葉を使ったデザートが人気`}</h3>
    <InstaImage postId="B9apElaAIkZ" mdxType="InstaImage" />
    <InstaImage postId="-Z7E-EkpNy" mdxType="InstaImage" />
    <p>{`お茶を使ったデザートが豊富に取り揃えられており、抹茶づくしのプレートからパフェまで幅広いスイーツを楽しむことができます。
スタイリッシュな空間の店内で、おしゃれな見た目と繊細な味のスイーツを堪能していただければと思います。`}</p>
    <InstaImage postId="B_2R7InFa4n" mdxType="InstaImage" />
    <InstaImage postId="B8DqmLrHiqd" mdxType="InstaImage" />
    <h3>{`行列情報`}</h3>
    <p>{`ランチタイムを過ぎるとスイーツを求めて行列ができることも少なくありません。なるべくランチタイム時間くらいにはお店に着くようにしておけば、待たずに入れることも多いのではないかと思います。原宿、表参道どちらからのアクセスがあるので、行列ができやすくなっています。`}</p>
    <ShopInfoBox shopId="brf4a4223akg00d4drq0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`bills 東急プラザ表参道原宿`}</h2>
    <InstaImage postId="CAnGvHwgMkZ" mdxType="InstaImage" />
    <InstaImage postId="CApn0GehPyT" mdxType="InstaImage" />
    <p>{`世界一の朝食と言われるくらい名高い、シドニー発祥のカフェ。
原宿駅から徒歩 5 分程度の東急プラザ表参道原宿 7F に位置し、明治通り沿いに店までの直通エレベーターも用意されていてアクセス抜群。
外にはテラス席があり、日中は光がほどよく差し込む空間は、落ち着きがあっておしゃれなカフェです！`}</p>
    <h3>{`1 番人気はリコッタパンケーキ`}</h3>
    <InstaImage postId="BuFoXymFckG" mdxType="InstaImage" />
    <InstaImage postId="CAG6ztql6pk" mdxType="InstaImage" />
    <p>{`Bills ではたくさんのメニューがありますが、厚みがあってインスタ映え間違いなしのおしゃれなパンケーキがこちら。
中はふわっとしているので、ナイフがスッと入るようなパンケーキになっており、味も濃厚で何度も通ってしまいたくなるような味です。
スムージーやコーヒーと一緒に食べると美味しさ倍増ですね！`}</p>
    <h3>{`行列を避けるならオープンを狙う`}</h3>
    <InstaImage postId="CBfkbwaDH1C" mdxType="InstaImage" />
    <p>{`東急プラザ 表参道原宿の開業時間は 11 時ですが、bills とスターバックスは 8:30 から開店しているそうです。
9 時頃に行っても既に半分の席が埋まっているほどの人気ですが、行列に並ばずに入店ができる時間帯はここが狙い目。
原宿駅からアクセスは近いので、早めに原宿に行ってカフェでゆっくりしてからショッピングなどに出かけるのもいいですよね。`}</p>
    <ShopInfoBox shopId="brmklui23akg009e18vg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ウズナオムオム`}</h2>
    <InstaImage postId="B1czxXwnspZ" mdxType="InstaImage" />
    <p>{`原宿のマンションの一室にある原宿でも隠れ家的なカフェの一つにもかかわらず、開店前から行列ができることもある人気店。
食べログの評価は 3.6 を超えるほどの人気で、パンケーキを主軸として、カレーなどのランチも提供している食べることができるのも魅力の一つ。`}</p>
    <h3>{`アットホームでおしゃれな空間`}</h3>
    <InstaImage postId="B86DfAmA-jp" mdxType="InstaImage" />
    <p>{`マンションの一室の扉を開けると、温かみのあるおしゃれな空間が飛び出してきます。4 人がけのソファーやカウンター席などが完備されており、雰囲気抜群の店内は、デート、友達とのランチ、ティータイムなどいろんなところで活用できるカフェ空間が特徴的。`}</p>
    <h3>{`おしゃれなメニュー`}</h3>
    <InstaImage postId="B8kw3UXAClW" mdxType="InstaImage" />
    <InstaImage postId="B8xHyL8gPlL" mdxType="InstaImage" />
    <InstaImage postId="B86DfAmA-jp" mdxType="InstaImage" />
    <p>{`もちっとした食感が楽しめるパンケーキは、季節のパンケーキ、定番のパンケーキ、お食事パンケーキなど、原宿のパンケーキ店と比較してもたくさんのおしゃれなメニューを選べるのが特徴になっています。
カフェという位置づけなので、カレーやランチメニューも揃っています。`}</p>
    <LinkWithThumbnail meta={uzunaomomPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="brd4mqq23akg009mvap0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿のおしゃれなカフェについて共有させていただきましたが、いかがでしたでしょうか。
老舗のレトロな落ち着いた雰囲気を堪能したい方も、定番の人気カフェ、日本茶に特化したカフェなど、その日の気分に合わせておしゃれなカフェを選んでいただければと思います。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;